import { IAction, ISuccessResponse } from '@Root/types'
import { put, takeLatest, select } from 'redux-saga/effects'
import * as Eff from 'redux-saga/effects' // tslint:disable-line:no-duplicate-imports
import showConfetti from '@Utils/ShowConfettiAnimation'

import Logger from '@Utils/Logger'

import {
  fetchProjectVersionSettingsTtsSuccess,
  fetchProjectVersionSettingsTtsFailure,
  setupTtsFailure,
  fetchTranslationLanguagesTtsSuccess,
  fetchTranslationLanguagesTtsFailure,
} from './actions'

import {
  ProjectVersionSettingsTtsActionTypes,
  IFetchProjectVersionSettingsTtsSuccessResponseBody,
  ISetupTtsSuccessResponseBody,
  IFetchProjectVersionSettingsTtsPayload,
  ISetupTtsPayload,
  IFetchTranslationLanguagesTtsPayload,
  IFetchTranslationLanguagesTtsSuccessResponseBody,
} from './types'

import {
  closeSetupProjectPopupTts,
} from '@SiteModules/Popup/actions'

import {
  fetchProjects,
} from '@SiteModules/Project/actions'

import * as API from './api'

const call: any = Eff.call

function* fetchProjectVersionSettingsTtsSaga(action: IAction<IFetchProjectVersionSettingsTtsPayload>) {
  try {
    const response: ISuccessResponse<IFetchProjectVersionSettingsTtsSuccessResponseBody> = yield call(API.fetchProjectVersionSettingsTts, action.payload)

    yield put(fetchProjectVersionSettingsTtsSuccess(response.data))
  } catch (e) {
    Logger.error(e, 'Language data could not be loaded')
    yield put(fetchProjectVersionSettingsTtsFailure())
  }
}

function* setupTtsSaga(action: IAction<ISetupTtsPayload>): Generator<any, any, any> {
  try {
    if (action.payload.includesTranscript) {
      const response: ISuccessResponse<ISetupTtsSuccessResponseBody> = yield call(API.setupTts, action.payload)
      window.location.href = response.data.editorUrl
    } else {
      yield call(API.setupTts, action.payload)
      yield put(closeSetupProjectPopupTts())
      showConfetti()

      const state = yield select()

      const searchText = state.projects.searchText
      const payloadFetchProjects = {
        workspaceId: action.payload.workspaceId,
        page: 1,
        selectedLabels: state.labels.selectedLabelIds,
        ...(searchText.length > 0 ? { searchText } : {}),
      }

      yield put(fetchProjects(payloadFetchProjects))
    }
  } catch (e) {
    if (action.payload.includesTranscript) {
      Logger.error(e, 'Project cannot be created')
    } else {
      Logger.error(e, 'Voice-over cannot be translated')
    }
    yield put(setupTtsFailure())
  }
}

function* fetchTranslationLanguagesTtsSaga(action: IAction<IFetchTranslationLanguagesTtsPayload>) {
  try {
    const response: ISuccessResponse<IFetchTranslationLanguagesTtsSuccessResponseBody> = yield call(API.fetchTranslationLanguagesTts, action.payload)

    yield put(fetchTranslationLanguagesTtsSuccess(response.data))
  } catch (e) {
    Logger.error(e, 'Translation languages could not be loaded')
    yield put(fetchTranslationLanguagesTtsFailure())
  }
}

function* projectVersionSettingsTtsSagas() {
  yield takeLatest(ProjectVersionSettingsTtsActionTypes.FETCH_PROJECT_VERSION_SETTINGS_TTS, fetchProjectVersionSettingsTtsSaga)
  yield takeLatest(ProjectVersionSettingsTtsActionTypes.SETUP_TTS, setupTtsSaga)
  yield takeLatest(ProjectVersionSettingsTtsActionTypes.FETCH_TRANSLATION_LANGUAGES_TTS, fetchTranslationLanguagesTtsSaga)
}

export default projectVersionSettingsTtsSagas
